/**
 * Clinical number formatting.
 *
 * Follows ISMP safe-notation rules: never emit a trailing zero ("1.0 mg" can be misread as
 * "10 mg") and always emit a leading zero ("0.5", not ".5").
 */
export function formatNumber(value: number): string {
  if (!Number.isFinite(value)) return '—';
  const abs = Math.abs(value);
  let rounded: number;
  if (abs === 0) rounded = 0;
  else if (abs < 1) rounded = Number(value.toPrecision(3));
  else if (abs < 10) rounded = Math.round(value * 100) / 100;
  else if (abs < 100) rounded = Math.round(value * 10) / 10;
  else rounded = Math.round(value);
  // String(Number) already strips trailing zeros and keeps the leading zero.
  return String(rounded);
}

export function formatRange(low: number, high?: number): string {
  if (high === undefined || high === low) return formatNumber(low);
  return `${formatNumber(low)}–${formatNumber(high)}`;
}

export function roundTo(value: number, step: number): number {
  return Math.round(value / step) * step;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
